import React from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentGeoentity, selectGeoentityRubricId } from '../../../store/geoentity/geoentity.selectors'
import { hasTouchSupport } from '../../Device'
import useErrorBoundaryCallback from '../../utils/useErrorBoundaryCallback'
import useEventCallback from '../../utils/useEventCallback'
import Marker from './Marker'
import s from './PoiMarker.less'
import classNames from 'classnames'
import { selectCurrentFuelFilterId, selectFuelInformation } from '../../../store/geoentity/fuels.selectors'

const PoiMarker = ({
  id,
  additionalInfo,
  isCurrent,
  shouldNavigateToPoiOnTap,
  navigateToPoi,
  focusPoi,
  unfocusPoi,
  vde,
  ...marker
}) => {
  const rubricId = selectGeoentityRubricId({}, { geoentity: marker })
  const currentGeoentity = useSelector(selectCurrentGeoentity)

  const fuelId = useSelector(selectCurrentFuelFilterId)
  const fuelInfos = useSelector(selectFuelInformation)
  const fuelColor = fuelInfos?.find(({ id }) => id === fuelId)?.color?.hex ?? '#E8E515'

  const poiFuelInfo = additionalInfo?.fuels?.find(({ id }) => id === fuelId)
  const poiFuelPrice = poiFuelInfo?.price
  const poiFuelAvailability = poiFuelInfo?.available

  const fuelInfo = {
    fuelColor,
    poiFuelPrice,
    poiFuelAvailability
  }

  const onSelect = useErrorBoundaryCallback(() => {
    // on PE, on a POI page with pois around,
    // we want to go to a POI on first tap
    if (shouldNavigateToPoiOnTap && currentGeoentity) {
      navigateToPoi({ id, additionalInfo, rubricId, vde })
    } else {
      focusPoi(id)
    }
  }, [navigateToPoi, focusPoi, shouldNavigateToPoiOnTap, currentGeoentity])

  const onUnselect = useErrorBoundaryCallback(() => {
    unfocusPoi(id)
  }, [unfocusPoi])

  const onClick = useEventCallback(() => {
    // on PE, on a search page,
    // on 1st tap we want to focus (display the popin poi info)
    // on 2nd tap to navigate to Poi
    if (hasTouchSupport() && !isCurrent) {
      onSelect()
    } else {
      navigateToPoi({ id, additionalInfo, rubricId, vde })
    }
  }, [isCurrent, onSelect, navigateToPoi])

  return (
    <Marker
      isCurrent={isCurrent}
      onSelect={onSelect}
      onUnselect={onUnselect}
      onClick={onClick}
      {...marker}
      fuelInfo={fuelInfo}
    >
      {(fuelInfo?.poiFuelPrice || fuelInfo?.poiFuelAvailability === false) && !isCurrent && (
        <div
          style={{ backgroundColor: fuelInfo?.poiFuelAvailability ? fuelInfo?.fuelColor : '#666' }}
          className={classNames(
            s.fuelInfo,
            !fuelInfo?.poiFuelAvailability && s.noFuel,
            marker?.offer === 'BRANDED' && s.branded
          )}
        >
          <span className={s.fuelText}>{fuelInfo?.poiFuelAvailability ? `${fuelInfo?.poiFuelPrice}€` : 'Rupture'}</span>
        </div>
      )}
    </Marker>
  )
}

export default React.memo(PoiMarker, (props, nextProps) => {
  const propsFuel = props.additionalInfo?.fuels?.length ?? 0
  const nextPropsFuel = nextProps.additionalInfo?.fuels?.length ?? 0
  return props.isCurrent === nextProps.isCurrent && propsFuel === nextPropsFuel
})
